
















































































































































import {
  BSidebar,
  BForm,
  BButton,
  BCard,
  BCol,
  BFormCheckbox,
  BDropdown,
  BFormGroup,
  BDropdownItem,
  BFormInput,
  BPagination,
  BRow,
  BTable,
  BFormRadio,
  BSpinner,
} from "bootstrap-vue";
import { Component, Prop, Vue } from "vue-property-decorator";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import { PartenaireCreateModel } from "@/api/models/partenaires/partenaire";
import SearchableVueSelect from "@/components/selects/SearchableVueSelect.vue";
import { PaginatedList } from "@/api/models/common/paginatedList";
import { errorAlert, successAlert } from "@/libs/sweetAlerts/alerts";

@Component({
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    BFormInput,
    BTable,
    BPagination,
    BDropdown,
    BDropdownItem,
    BSidebar,
    BForm,
    BFormGroup,
    BFormRadio,
    BFormCheckbox,
    BSpinner,
    ValidationProvider,
    ValidationObserver,
    SearchableVueSelect,
  },
  name: "create-partenaire",
})
export default class CreatePartenaire extends Vue {
  @Prop({ required: true, type: Boolean })
  isAddNewPartenaireSidebarActive!: boolean;
  loading = false;

  required = required;
  listTypesServices: any[] = [];
  totalCountTypeServices = 0;

  newPartenaire: PartenaireCreateModel = {};
  listSecteursActivite = new PaginatedList<any>();

  async created() {
    await this.loadTypesServices();
  }
  resetForm() {
    this.newPartenaire = {};
  }

  async loadTypesServices() {
    await this.$http.myressif.parametres
      .getByNom("type_services_partenaire")
      .then((res: any) => {
        this.listTypesServices = res ? JSON.parse(res.valeur) : [];
      });
  }

  async submit() {
    this.loading = true;
    await this.$http.myressif.partenaires
      .post(this.newPartenaire)
      .then(
        async (response: any) => {
          successAlert.fire({
            timer: 3500,
            title: "Création d'un partenaire",
            text: "Partenaire créé dans MyRessif avec succès",
          });
        },
        (error: any) => {
          if (
            error?.response?.data?.errors &&
            Object.keys(error.response.data.errors).length
          ) {
            errorAlert.fire({
              text: error.response.data.errors[
                Object.keys(error.response.data.errors)[0]
              ],
            });
          } else {
            errorAlert.fire({
              text: error?.response?.data?.detail ?? error.message,
            });
          }
        }
      )
      .finally(() => {
        this.$emit("refetch-data");
        this.$emit("update:is-add-new-partenaire-sidebar-active", false);
        this.loading = false;
      });
  }
}
